module.exports = __webpack_public_path__ + "img/night-parties.ff24a790.jpg";